<template>
  <div>
    <div style="background-color: white; padding: 15px;">
      <div style="padding-bottom: 15px; border-bottom: 1px solid #e7e7e7">
        <span style="font-size: 13px; color:#97a8be">首页 / 项目管理 / 股票列表 / 增仓</span>
      </div>
      <div style="padding-top: 15px;">
        <table width="100%">
          <tr>
            <td class="leftTd">
              <span style="color: red">* </span>可申购量
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="stock" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              <span style="color: red">* </span>日利率
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="rate" type="number" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              <span style="color: red">* </span>周期
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="day" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              <span style="color: red">* </span>进度
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="progress" class="boxText"/>
            </td>
          </tr>

        </table>
      </div>

      <div style="padding-top: 15px; padding-bottom: 25px; padding-left: 50px">
        <input @click="addAdmin" type="button" style="cursor: pointer; padding: 10px 25px; border-radius: 3px; background-color: #1890ff; border: 1px solid #1890ff; color: white" value="增仓" />
        <input @click="goback" type="button" style="cursor: pointer; padding: 10px 25px; border-radius: 3px; background-color: #ffffff; border: 1px solid #dbdbdb; margin-left: 15px; color: #606266" value="返回" />
      </div>
    </div>

  </div>
</template>

<script>

import {closeLoading, DO_NET_URL, loading, toask} from "@/config/config";
import {axiosGet, axiosPost, axiosPostJson} from "@/main";

export default {
  name: "AddStockChild",
  data(){
    return{
      stock:"",
      rate:"",
      day:"",
      progress:"",
    }
  },
  mounted(){
    let that=this
    if(localStorage.getItem("iwa_token")==null||localStorage.getItem("iwa_token")==""){
      setTimeout(function (){
        that.$router.replace('index')
      },600);
    }
    // let json=JSON.parse(localStorage.getItem("UPDATEOBJ"))
    // console.log(json)
    // this.account=json.userAccount
    // this.code=json.userCode
    // this.userType=json.userType
    // this.nickName=json.userNickName
    // this.userState=json.userState
    // this.usdtAddress=json.userUsdtAddress
    // this.num=json.userTransferNum
    // this.name=json.userName
    // this.card=json.userCard
    // this.email=json.userEmail
    // this.phone=json.userPhone

  },
  methods: {
    bindBank(){
      // this.$emit("send","bindBank")
      this.openCenteredWindow("#/bindBank", 800,600)
    },
    openCenteredWindow(url, width, height) {
      // 计算窗口居中的位置
      var left = (screen.width / 2) - (width / 2);
      var top = (screen.height / 2) - (height / 2);

      // 打开窗口
      window.open(url, '_blank', `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=${width}, height=${height}, top=${top}, left=${left}`);
    },
    resetPwd(type){
      let that=this
      if(confirm("确认重置"+(type==0?"登录密码":"支付密码")+"吗？")){
        loading("请求中")
        axiosPost(DO_NET_URL+"user/ResetPwd?code="+this.code+"&type="+type,"",function (res){
          closeLoading()
          alert(res.data);
        })
      }
    },
    addAdmin(){
      let that=this
      if(this.stock==""){
        toask("请输入可申购量！",6)
        return;
      }
      if(this.rate==""){
        toask("请输入日利率！",6)
        return;
      }
      if(this.day==""){
        toask("请输入周期！",6)
        return;
      }
      if(this.progress==""){
        toask("请输入进度！",6)
        return;
      }
      loading("请求中")
      let json=JSON.parse(localStorage.getItem("UPDATEOBJ"))
      axiosPost(DO_NET_URL+"project/AddStock?projectId="+json.projectId.toString()+"&rate="+this.rate+"&day="+this.day+"&num="+this.stock+"&progress="+this.progress,"",function (res){
        closeLoading()
        if(res.code==200){
          toask("操作成功",6)
          setTimeout(function (){
            that.$emit("send",'updateStock')
          },600)
        }else{
          toask(res.data,6)
        }
      })
    },
    goback(){
      this.$emit("send",'updateStock')
    },

  }
}
</script>

<style scoped>
.boxText{-webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: 12px;
  height: 40px;
  /*line-height: 40px;*/
  outline: none;
  padding: 0 15px;
  -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  width: 50%;}
.leftTd{text-align: right;
  vertical-align: middle;
  font-size: 12px;
  color: #606266;
  line-height: 40px;
  padding: 15px 12px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;font-weight: 700; width: 120px}
.addBtn{color: #1890ff;background: #e8f4ff; border: 1px solid #1890ff; cursor: pointer; float: left; font-size: 12px;padding: 7px 15px;border-radius: 3px;}
.th{border-bottom:1px solid #dfe6ec; text-align: left; padding:0 10px;word-break: break-word;background-color: #f8f8f9;color: #515a6e;height: 40px;font-size: 12px;}
.td{border-bottom:1px solid #dfe6ec;padding:0 10px; word-break:break-word;background-color: #ffffff;color: #606266;height: 40px;font-size: 12px;}
</style>